import { Component } from '@angular/core';

@Component({
    selector: 'new-indicator',
    styles: [`
        .dot {
            height: 10px;
            width: 10px;
            background-color: #F88F1E;
            border-radius: 50%;
            display: inline-block;
        }
    `],
    template: `
        <span class="dot"></span>
    `
})
export class NewIndicatorComponent {
}